/**
 * @file annotationSearchInitialQuery.saga.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 *  https://stackoverflow.com/questions/47086846/react-how-to-navigate-router-in-redux-saga
 * 
 * @author don michael
 * @since Feb 07, 2023 10:58
 */
import { call, put, takeLeading } from 'redux-saga/effects';
import axiosClient from 'src/services/axiosClient.js';

import standardMessages from 'src/services/notifications/standardMessages';

import {
    enqueueMessage,
} from 'src/store/actions/global.actions';

import { stringExists } from 'src/@common/utilities';

import {
    ANNOTATION_SEARCH_INITIAL_QUERY_REQUEST,
    annotationSearchInitialQuerySuccess,
    annotationSearchInitialQueryFailure,
} from 'src/store/actions/annotationSearch/annotationSearchDb.actions';

import { dataLoadingSet } from 'src/store/actions/global.actions';

import handleSagaErrors from 'src/store/sagas/handleSagaErrors';

function callApi(payload) {
    const url = '/annotationSearch/initialQuery';

    const baseUrl = import.meta.env.VITE_APP_API_BASE_URL;

    const config = {
        method: 'post',
        baseURL: baseUrl,
        url,
        data: {
            searchTerm: payload.searchTerm,
        },

    };

    return new Promise((resolve, reject) => {
        axiosClient(config)
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                console.error('initialQuery.saga.err@1', err)
                reject(err);
            });
    });
}

function* createRequestSaga(action) {

    try {
        yield put(dataLoadingSet(true));

        const resp = yield call(callApi, action.payload);

        if (stringExists(resp.payload.serverMessage)) {
            yield put(enqueueMessage(
                resp.payload.serverMessage,
                standardMessages.generalInfoMessage.options)
            );
        }

        yield put(annotationSearchInitialQuerySuccess(resp.payload));

    } catch (error) {

        console.error('initialQuery.saga.err@2', error)
        yield put(annotationSearchInitialQueryFailure(error));

        handleSagaErrors(error);

    } finally {
        yield put(dataLoadingSet(false));
    }

}

export default function* createRequestMonitor() {
    yield takeLeading(ANNOTATION_SEARCH_INITIAL_QUERY_REQUEST, createRequestSaga);
}
